export const NAMESPACE = 'embedded-container';

export const EMBEDDED_JOB = 'job';
export const EMBEDDED_VIDEO = 'video';
export const EMBEDDED_PAGE_TYPES = [EMBEDDED_JOB, EMBEDDED_VIDEO];
export const EMBEDDED_ALLOWED_EXTENSIONS = ['js'];
